import React from 'react';
import { MarkerF } from '@react-google-maps/api';
import PropTypes from 'prop-types';

export default class SearchpointMarker extends React.PureComponent {
  static propTypes = {
    position: PropTypes.shape({}),
    iconOptions: PropTypes.shape({
      iconUrl: PropTypes.string,
      sameIconForRetina: PropTypes.bool
    })
  };

  static defaultProps = {
    position: { lat: 0, lng: 0 },
    iconOptions: {
      iconUrl: '/static/assets/map/pin.png',
      sameIconForRetina: true
    }
  };

  render() {
    const { model, iconOptions } = this.props;

    return (
      <MarkerF
        position={{ lat: model.lat, lng: model.lng }}
        icon={{
          url: iconOptions.iconUrl
        }}
      />
    );
  }
}
